import { aboutContent } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide mb-3">
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
              {aboutContent.title}
            </h2>
          </div>

          <div className="bg-background-100 rounded-2xl border border-background-200/70 p-8 md:p-10">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              {aboutContent.intro}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {aboutContent.desc}
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {aboutContent.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="text-center p-4 rounded-xl bg-background-50 border border-background-200/70"
                >
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-500 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}